// THIS FILE IS AUTO-GENERATED. DO NOT MODIFY IT.
// Please edit ./night.theme.ts instead, then run `yarn theme:build`
import { css } from '@linaria/core'

export default css`
  --gray00: #0d0f10;
  --gray00a: rgba(0, 0, 0, 0);
  --gray02: #1e1d1d;
  --gray02a: rgba(255, 210, 195, 0.067);
  --gray03: #272626;
  --gray03a: rgba(255, 226, 216, 0.102);
  --gray05: #313030;
  --gray05a: rgba(255, 234, 227, 0.141);
  --gray10: #3f3e3e;
  --gray10a: rgba(255, 240, 235, 0.196);
  --gray20: #4e4d4d;
  --gray20a: rgba(255, 243, 239, 0.255);
  --gray30: #5f5f5f;
  --gray30a: rgba(255, 249, 246, 0.322);
  --gray40: #737272;
  --gray40a: rgba(255, 248, 245, 0.4);
  --gray50: #878686;
  --gray50a: rgba(255, 249, 247, 0.478);
  --gray60: #9d9c9c;
  --gray60a: rgba(255, 250, 248, 0.565);
  --gray70: #b4b3b3;
  --gray70a: rgba(255, 250, 249, 0.655);
  --gray80: #cfcece;
  --gray80a: rgba(255, 251, 250, 0.761);
  --gray90: #ebebeb;
  --gray90a: rgba(255, 253, 252, 0.871);
  --gray100: #ffffff;
  --gray100a: rgba(255, 253, 252, 0.949);
  --blue02: #0c1e2e;
  --blue02a: rgba(0, 128, 255, 0.118);
  --blue03: #0c273f;
  --blue03a: rgba(0, 130, 255, 0.184);
  --blue05: #043255;
  --blue05a: rgba(0, 129, 255, 0.271);
  --blue10: #004167;
  --blue10a: rgba(0, 147, 255, 0.341);
  --blue20: #025377;
  --blue20a: rgba(0, 168, 255, 0.404);
  --blue30: #066789;
  --blue30a: rgba(0, 185, 255, 0.475);
  --blue40: #047c9d;
  --blue40a: rgba(0, 197, 255, 0.553);
  --blue50: #1292b2;
  --blue50a: rgba(8, 206, 255, 0.635);
  --blue60: #33aac7;
  --blue60a: rgba(53, 216, 255, 0.718);
  --blue70: #56c2db;
  --blue70a: rgba(92, 225, 255, 0.796);
  --blue80: #8adbed;
  --blue80a: rgba(144, 235, 255, 0.867);
  --blue90: #c4eaf4;
  --blue90a: rgba(205, 245, 255, 0.894);
  --green02: #0b2210;
  --green02a: rgba(0, 255, 0, 0.075);
  --green03: #0b2c13;
  --green03a: rgba(0, 255, 26, 0.114);
  --green05: #053817;
  --green05a: rgba(0, 255, 44, 0.161);
  --green10: #094819;
  --green10a: rgba(0, 255, 40, 0.224);
  --green20: #185919;
  --green20a: rgba(38, 255, 31, 0.29);
  --green30: #2e6d18;
  --green30a: rgba(90, 255, 22, 0.369);
  --green40: #46801b;
  --green40a: rgba(129, 255, 25, 0.443);
  --green50: #60941d;
  --green50a: rgba(159, 255, 25, 0.522);
  --green60: #7dab1d;
  --green60a: rgba(183, 255, 21, 0.612);
  --green70: #a1c01a;
  --green70a: rgba(213, 255, 14, 0.694);
  --green80: #c9d858;
  --green80a: rgba(239, 255, 91, 0.788);
  --green90: #e5e8aa;
  --green90a: rgba(254, 255, 181, 0.851);
  --yellow02: #331306;
  --yellow02a: rgba(255, 27, 0, 0.149);
  --yellow03: #461805;
  --yellow03a: rgba(255, 40, 0, 0.224);
  --yellow05: #5a1b01;
  --yellow05a: rgba(255, 40, 0, 0.302);
  --yellow10: #742100;
  --yellow10a: rgba(255, 45, 0, 0.404);
  --yellow20: #8e2b01;
  --yellow20a: rgba(255, 55, 0, 0.506);
  --yellow30: #a73d01;
  --yellow30a: rgba(255, 76, 0, 0.604);
  --yellow40: #bf5003;
  --yellow40a: rgba(255, 93, 0, 0.698);
  --yellow50: #d36901;
  --yellow50a: rgba(255, 116, 0, 0.776);
  --yellow60: #e38602;
  --yellow60a: rgba(255, 142, 0, 0.839);
  --yellow70: #efa60b;
  --yellow70a: rgba(255, 170, 0, 0.886);
  --yellow80: #f9c83f;
  --yellow80a: rgba(255, 200, 51, 0.925);
  --yellow90: #fce38d;
  --yellow90a: rgba(255, 226, 133, 0.937);
  --red02: #3a0917;
  --red02a: rgba(255, 0, 40, 0.176);
  --red03: #52021f;
  --red03a: rgba(255, 0, 55, 0.271);
  --red05: #660128;
  --red05a: rgba(255, 0, 69, 0.349);
  --red10: #7d0735;
  --red10a: rgba(255, 0, 84, 0.439);
  --red20: #971344;
  --red20a: rgba(255, 7, 96, 0.541);
  --red30: #b61f54;
  --red30a: rgba(255, 24, 103, 0.663);
  --red40: #d42d66;
  --red40a: rgba(255, 38, 110, 0.78);
  --red50: #ec4979;
  --red50a: rgba(255, 66, 120, 0.875);
  --red60: #fa6d8f;
  --red60a: rgba(255, 101, 137, 0.929);
  --red70: #fc96a9;
  --red70a: rgba(255, 144, 163, 0.937);
  --red80: #fdbfc5;
  --red80a: rgba(255, 187, 192, 0.941);
  --red90: #fedcdf;
  --red90a: rgba(255, 217, 219, 0.945);
  --purple02: #281239;
  --purple02a: rgba(168, 19, 255, 0.161);
  --purple03: #381452;
  --purple03a: rgba(166, 19, 255, 0.259);
  --purple05: #47156b;
  --purple05a: rgba(163, 17, 255, 0.357);
  --purple10: #5a1d89;
  --purple10a: rgba(162, 30, 255, 0.475);
  --purple20: #6e27a6;
  --purple20a: rgba(165, 41, 255, 0.588);
  --purple30: #8437c2;
  --purple30a: rgba(170, 57, 255, 0.698);
  --purple40: #974ed5;
  --purple40a: rgba(179, 82, 255, 0.773);
  --purple50: #aa67e6;
  --purple50a: rgba(187, 105, 255, 0.839);
  --purple60: #bb84ef;
  --purple60a: rgba(199, 134, 255, 0.875);
  --purple70: #cda3f3;
  --purple70a: rgba(216, 166, 255, 0.89);
  --purple80: #dfc4f6;
  --purple80a: rgba(233, 201, 255, 0.902);
  --purple90: #eddef9;
  --purple90a: rgba(245, 227, 255, 0.914);
  --danger02: #370f0d;
  --danger02a: rgba(255, 0, 0, 0.165);
  --danger03: #4a1110;
  --danger03a: rgba(255, 8, 0, 0.239);
  --danger05: #620e11;
  --danger05a: rgba(255, 0, 3, 0.333);
  --danger10: #7e1015;
  --danger10a: rgba(255, 2, 11, 0.443);
  --danger20: #9a161a;
  --danger20a: rgba(255, 13, 18, 0.553);
  --danger30: #b82422;
  --danger30a: rgba(255, 31, 27, 0.671);
  --danger40: #d23a2f;
  --danger40a: rgba(255, 56, 40, 0.773);
  --danger50: #e65642;
  --danger50a: rgba(255, 83, 59, 0.851);
  --danger60: #f7765b;
  --danger60a: rgba(255, 112, 82, 0.918);
  --danger70: #fe997e;
  --danger70a: rgba(255, 146, 116, 0.945);
  --danger80: #fdc1ad;
  --danger80a: rgba(255, 189, 167, 0.941);
  --danger90: #fddecf;
  --danger90a: rgba(255, 220, 203, 0.941);
  --elev-veil-color: white;
  --gradient-color-base: 6%;

  color-scheme: dark;
  background: var(--gray00);
  color: var(--gray100);
  &:not([transparent]) {
    background: var(--gray00);
  }
`
